module.exports = __webpack_public_path__ + "static/media/mrvan.e68f39de.png";